// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateModal_wrapper__fiJ1-","dialog__close":"CreateModal_dialog__close__QqKPW"};